import { AttachmentValue } from '../../data-objects'
import { FieldDefinition } from '../field-definitions'

export class AttachmentFieldDefinition extends FieldDefinition {
  public accept: string
  public canDownload: boolean

  constructor(field?: AttachmentFieldDefinition) {
    super(field)
    this.accept = field ? field.accept : '*'
    this.canDownload = field?.canDownload ?? true
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): any {
    const toReturn = new AttachmentValue()
    return toReturn
  }
}
